/**
 * mwApp.reports module <br>
 *
 *
 * @namespace mwApp/reports
 */

import ReportsCtrl from './reports.controller'
import StreamReportsCtrl from './streamReports.controller'
import AddReportCtrl from './addReport.controller'
import AddStreamReportCtrl from './addStreamReport.controller'
import ReportTemplatesCtrl from './reportTemplates.controller'
import GeneratedReportsCtrl from './generatedReports.controller'
import reportsConfig from './reports.config'

import { generateFilterFields } from './reports.directives'
import reportsDataFactory from './reportsData.factory'
import AddSubscribersReportCtrl from './addSubscribersReport.controller'
import SubscribersReportsCtrl from './subscribersReports.controller'
import AddUsersReportsCtrl from './addUsersReports.controller'
import UsersReportsCtrl from './usersReports.controller'
import AddSubscribersActivityReportsCtrl from './addSubscribersActivityReports.controller'
import SubscribersActivityReportsCtrl from './subscribersActivityReports.controller'
import AddFinancialReportCtrl from './addFinancialReport.controller'
import FinancialReportsCtrl from './financialReports.controller'
import AddTransactionReportCtrl from './addTransactionReport.controller'
import TransactionReportsCtrl from './transactionReports.controller'

export default
angular.module('mwApp.reports', [])
  .config(reportsConfig)
  .filter('encodeURIComponent', () => encodeURIComponent)
  .directive('generateFilterFields', generateFilterFields)
  .controller('ReportsCtrl', ReportsCtrl)
  .controller('StreamReportsCtrl', StreamReportsCtrl)
  .controller('SubscribersReportsCtrl', SubscribersReportsCtrl)
  .controller('UsersReportsCtrl', UsersReportsCtrl)
  .controller('AddReportCtrl', AddReportCtrl)
  .controller('AddStreamReportCtrl', AddStreamReportCtrl)
  .controller('AddUsersReportsCtrl', AddUsersReportsCtrl)
  .controller('AddFinancialReportCtrl', AddFinancialReportCtrl)
  .controller('AddTransactionReportCtrl', AddTransactionReportCtrl)
  .controller('AddSubscribersReportCtrl', AddSubscribersReportCtrl)
  .controller('ReportTemplatesCtrl', ReportTemplatesCtrl)
  .controller('GeneratedReportsCtrl', GeneratedReportsCtrl)
  .controller('AddSubscribersActivityReportsCtrl', AddSubscribersActivityReportsCtrl)
  .controller('SubscribersActivityReportsCtrl', SubscribersActivityReportsCtrl)
  .controller('FinancialReportsCtrl', FinancialReportsCtrl)
  .controller('TransactionReportsCtrl', TransactionReportsCtrl)
  .factory('commonData', reportsDataFactory)
